var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatNumber } from "module/main/util";
import { cx } from "module/main/util";
export var Panel = function (_a) {
    var className = _a.className, _b = _a.padded, padded = _b === void 0 ? true : _b, children = _a.children, props = __rest(_a, ["className", "padded", "children"]);
    return (_jsx("div", __assign({ className: cx("rounded-xl border border-sherpaCream bg-white shadow-[0_1px_4px_rgba(15,23,42,0.08)]", padded && "p-5", className) }, props, { children: children })));
};
export var SectionTitle = function (_a) {
    var eyebrow = _a.eyebrow, title = _a.title, className = _a.className;
    return (_jsxs("div", { className: cx("mb-3", className), children: [eyebrow ? (_jsx("div", { className: "mb-1 text-[11px] font-extrabold uppercase tracking-wide text-sherpaTahoeTeal", children: eyebrow })) : null, title ? _jsx("h2", { className: "text-xl font-extrabold text-ink", children: title }) : null] }));
};
export var FeatureList = function (_a) {
    var items = _a.items, className = _a.className;
    return (_jsx("ul", { className: cx("m-0 list-none space-y-2 p-0 text-sm text-sherpaGray", className), children: items.map(function (item, index) { return (_jsxs("li", { className: "flex gap-2", children: [_jsx("span", { className: "mt-0.5 text-sherpaFern", children: "\u2713" }), _jsx("span", { children: item })] }, index)); }) }));
};
export var Metric = function (_a) {
    var label = _a.label, value = _a.value, children = _a.children;
    return (_jsxs("div", { className: "min-w-[140px] border-r border-sherpaCreamier px-5 last:border-r-0", children: [_jsx("div", { className: "text-[11px] font-extrabold uppercase tracking-wide text-label", children: label }), _jsx("div", { className: "mt-2 text-xl font-extrabold text-ink", children: value }), children ? _jsx("div", { className: "mt-2 text-xs text-label", children: children }) : null] }));
};
export var endpointRows = [
    {
        method: "PUT",
        tag: "Core",
        endpoint: "Property by Address",
        path: "/api/properties",
        description: "Get owner contact data and full property details from a street address.",
    },
    {
        method: "PUT",
        endpoint: "Property by APN",
        path: "/api/apn_properties",
        description: "Retrieve owner records and property data using an Assessor's Parcel Number.",
    },
    {
        method: "PUT",
        endpoint: "Property Details",
        path: "/api/property_details",
        description: "Return property details based on address and APN data.",
    },
    {
        method: "PUT",
        endpoint: "Property Search",
        path: "/api/property_search",
        description: "Return a list of properties matching geographical and property filters.",
    },
    {
        method: "PUT",
        endpoint: "Person Lookup",
        path: "/api/person",
        description: "Skip trace an individual — returns phones, emails, and rich identity data.",
    },
    {
        method: "PUT",
        endpoint: "Reverse Phone Lookup",
        path: "/api/reverse_phone",
        description: "Find an individual — returns basic identity data (name, phones, emails).",
    },
    {
        method: "PUT",
        endpoint: "Criminal Check",
        path: "/api/criminal",
        description: "Check criminal background — returns criminal offenses for a given individual.",
    },
    {
        method: "PUT",
        endpoint: "Workplace Records",
        path: "/api/workplace",
        description: "Return rich workplace data for a given individual.",
    },
    {
        method: "PUT",
        endpoint: "Business Lookup",
        path: "/api/business",
        description: "Look up contact and ownership data for a business entity.",
    },
    {
        method: "PUT",
        endpoint: "DNC Status",
        path: "/api/dnc/status",
        description: "Check a phone number against the National Do Not Call Registry.",
    },
];
export var ownerDataPills = [
    "Owner Name",
    "Phone",
    "Email",
    "Mailing Address",
    "Entity Type",
    "LLC / Trust",
    "APN",
    "Property Type",
];
export var renderUsageBlockSection = function (blockOptions) {
    return (blockOptions === null || blockOptions === void 0 ? void 0 : blockOptions.length)
        ? blockOptions.map(function (option) { return ({
            key: option.blockId,
            price: "$".concat(formatNumber({ value: option.finalPrice })),
            hits: "".concat(formatNumber({ value: option.allocation }), " hits"),
            cost: "$".concat(formatNumber({ value: option.approximateCostPerLookup }), " / hit"),
            option: option,
        }); })
        : [];
};
export var planCopy = {
    api_payg: {
        title: "Pay As You Go",
        short: "200 lookups/mo · Up to 1,000 accrued · Usage blocks · DNC add-on · Cancel anytime",
    },
    api_payg_plus: {
        title: "Pay As You Go Plus",
        short: "1,000 lookups/mo · Up to 5,000 accrued · Usage blocks · DNC add-on · Best value",
    },
    api_custom_contract: {
        title: "Custom Contract",
        short: "Custom plans · Volume pricing · Dedicated manager · SLA & uptime guarantees",
    },
};
export var getPlanTitle = function (plan) {
    var _a;
    if (!plan)
        return "Free trial";
    return ((_a = planCopy[plan.id]) === null || _a === void 0 ? void 0 : _a.title) || plan.name;
};
export var openBillingPortal = function (userInfo) {
    var _a;
    if (userInfo.chargeHistoryURL)
        window.open(userInfo.chargeHistoryURL, "_blank", "noopener,noreferrer");
    else
        (_a = document.querySelector("#plan-options")) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
};
export var billingDisableReasons = ["sub_past_due", "custom_charge_failed"];
export var disableReasonCopy = {
    sub_past_due: "Your subscription has past due charges. Update your billing information to re-enable this API key.",
    custom_charge_failed: "A pending usage charge failed. Update or confirm your billing information to re-enable this API key.",
};
export var isBillingDisableReason = function (reason) {
    return !!reason && billingDisableReasons.includes(reason);
};
export var formatLookupPrice = function (value) {
    var _a;
    var normalized = value || "0";
    var decimalPlaces = ((_a = normalized.split(".")[1]) === null || _a === void 0 ? void 0 : _a.length) || 0;
    return decimalPlaces < 2 ? parseFloat(normalized).toFixed(2) : normalized;
};
